import axios from "axios";
import { URL } from "./constants";
import Vue from "vue";
import { getUrl } from "@api/constants";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  return JSON.parse(window.atob(base64));
}

function getQueryParam(name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[[\]]/g, "\\$&");
  regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2]);
}

function getToken(tokenName) {
  return localStorage.getItem(tokenName) || undefined;
}

function setToken(tokenName, tokenValue) {
  localStorage.removeItem(tokenName, "");
  if (!tokenValue) return;
  localStorage.setItem(tokenName, tokenValue);
}

const reactiveTokensStore = new Vue({
  data: function() {
    return {
      $accessToken: getToken("jwt_access_token"),
      $refreshToken: getToken("jwt_refresh_token")
      // __twoFactorToken: getToken('jwt_two_factor_token')
    };
  },
  computed: {
    accessToken: {
      get() {
        return this._data.$accessToken;
      },
      set(tokenValue) {
        this._data.$accessToken = tokenValue;
        setToken("jwt_access_token", tokenValue);
      }
    },
    refreshToken: {
      get() {
        return this._data.$refreshToken;
      },
      set(tokenValue) {
        this._data.$refreshToken = tokenValue;
        setToken("jwt_refresh_token", tokenValue);
      }
    }
    // twoFactorToken: {
    //   get () {
    //     return this._data.__twoFactorToken
    //   },
    //   set (tokenValue) {
    //     this._data.__twoFactorToken = tokenValue
    //     setToken('jwt_two_factor_token', tokenValue)
    //   }
    // }
  }
});

class AuthClient {
  get passwordResetUserId() {
    return getQueryParam("passwordResetUserId");
  }
  get passwordResetToken() {
    return getQueryParam("passwordResetToken");
  }
  get authenticated() {
    return (
      !!reactiveTokensStore.accessToken && !!reactiveTokensStore.refreshToken
    );
  }
  // register (email, password, referral, emailConfirmationRedirectUrl, recaptcha) {
  //   emailConfirmationRedirectUrl = resolveUrl(emailConfirmationRedirectUrl)
  //   return axios.post(getUrl(URL.POST_REGISTER), {
  //     email,
  //     password,
  //     ReferralUID: referral,
  //     emailConfirmationRedirectUrl,
  //     recaptcha
  //   })
  // }
  login(email, password) {
    return axios
      .post(getUrl(URL.POST_LOGIN), {
        email,
        password
      })
      .then(resp => {
        reactiveTokensStore.accessToken = resp.data.access_token;
        reactiveTokensStore.refreshToken = resp.data.refresh_token;
        return resp;
      });
  }
  setAccessToken(token) {
    reactiveTokensStore.accessToken = token;
  }
  setRefreshToken(token) {
    reactiveTokensStore.refreshToken = token;
  }
  // twoFactorLogin (code) {
  //   return axios.post(getUrl(URL.POST_LOGIN_TWO_FACTOR), {
  //     provider: 'GoogleAuthenticator',
  //     rememberBrowser: false,
  //     code: code
  //   }, {
  //     __jwt_retry: true,
  //     headers: {
  //       'Authorization': reactiveTokensStore.twoFactorToken
  //         ? `Bearer ${reactiveTokensStore.twoFactorToken}` : ''
  //     }
  //   }).then(resp => {
  //     if (resp.data.lockoutEnd != undefined) {
  //       throw {
  //         response: resp
  //       }
  //     }
  //     reactiveTokensStore.accessToken = resp.data.token
  //     reactiveTokensStore.refreshToken = resp.data.refreshToken
  //     return resp
  //   })
  // }
  forgotPassword(email) {
    // redirectUrl = resolveUrl(redirectUrl);
    return axios.post(getUrl(URL.POST_FORGOT_PASSWORD), {
      email,
      recaptcha
    });
  }
  resetPassword(password) {
    return axios.post(getUrl(URL.POST_RESET_PASSWORD), {
      userId: this.passwordResetUserId,
      code: this.passwordResetToken,
      password
    });
  }
  logout() {
    return new Promise((resolve, reject) => {
      reactiveTokensStore.accessToken = undefined;
      reactiveTokensStore.refreshToken = undefined;
      resolve();
    });
  }
  refreshTokens(error) {
    if (this.__refreshPromise) return this.__refreshPromise;
    if (!reactiveTokensStore.refreshToken) return Promise.reject(error);
    this.__refreshPromise = axios
      .post(
        getUrl(URL.POST_JWT_REFRESH),
        {
          refreshToken: reactiveTokensStore.refreshToken
        },
        {
          __jwt_retry: true
          // headers: {
          //   'Authorization': reactiveTokensStore.refreshToken
          //     ? `Bearer ${reactiveTokensStore.refreshToken}` : ''
          // }
        }
      )
      .then(resp => {
        this.__refreshPromise = undefined;
        reactiveTokensStore.accessToken = resp.data.access_token;
        reactiveTokensStore.refreshToken = resp.data.refresh_token;
        return resp;
      })
      .catch(error => {
        this.__refreshPromise = undefined;
        if (error.response && error.response.status === 401) {
          return this.logout().then(() => {
            if (this.unauthorizedCallback) this.unauthorizedCallback();
            else throw error;
          });
        }
        throw error;
      });
    return this.__refreshPromise;
  }
  getEmail() {
    if (this.authenticated) {
      return parseJwt(reactiveTokensStore.accessToken).sub;
    } else {
      return "";
    }
  }
  getDetails() {
    return axios.get(getUrl(URL.GET_ACCOUNT_DETAILS));
  }

  addAxiosInterceptor(unauthorizedCallback) {
    this.unauthorizedCallback = unauthorizedCallback;
    axios.interceptors.request.use(config => {
      if (!config.__jwt_retry) {
        config.headers["Authorization"] = reactiveTokensStore.accessToken
          ? `Bearer ${reactiveTokensStore.accessToken}`
          : "";
      }
      return config;
    });
    axios.interceptors.response.use(undefined, error => {
      const originalRequest = error.config;
      if (
        error.response &&
        error.response.status === 401 &&
        !originalRequest.__jwt_retry
      ) {
        originalRequest.__jwt_retry = true;
        return this.refreshTokens(error).then(resp => {
          originalRequest.headers[
            "Authorization"
          ] = reactiveTokensStore.accessToken
            ? `Bearer ${reactiveTokensStore.accessToken}`
            : "";
          return axios(originalRequest);
        });
      }
      return Promise.reject(error);
    });
  }
}

export const authClient = new AuthClient();



// WEBPACK FOOTER //
// ./src/api/auth.js